import { useCallback } from 'react'
import moment from 'moment-timezone'

export const useDateSlotConversion = (timezone) => {
  const convertDateAndSlotToUTC = useCallback(
    (selectedDateStr, slotStartUTC, slotEndUTC = null) => {
      if (!selectedDateStr || !slotStartUTC || !timezone) {
        return { start: null, end: null }
      }

      const slotInUserTimezone = moment.utc(slotStartUTC).tz(timezone)
      const timeOfDay = {
        hour: slotInUserTimezone.hour(),
        minute: slotInUserTimezone.minute(),
        second: slotInUserTimezone.second(),
      }

      const selectedDateInTimezone = moment.tz(selectedDateStr, timezone)
      const slotStartInUTC = moment
        .tz(
          [
            selectedDateInTimezone.year(),
            selectedDateInTimezone.month(),
            selectedDateInTimezone.date(),
            timeOfDay.hour,
            timeOfDay.minute,
            timeOfDay.second || 0,
          ],
          timezone,
        )
        .utc()

      let slotEndInUTC = null
      if (slotEndUTC) {
        const slotEndInUserTimezone = moment.utc(slotEndUTC).tz(timezone)
        const endTimeOfDay = {
          hour: slotEndInUserTimezone.hour(),
          minute: slotEndInUserTimezone.minute(),
          second: slotEndInUserTimezone.second(),
        }

        slotEndInUTC = moment
          .tz(
            [
              selectedDateInTimezone.year(),
              selectedDateInTimezone.month(),
              selectedDateInTimezone.date(),
              endTimeOfDay.hour,
              endTimeOfDay.minute,
              endTimeOfDay.second || 0,
            ],
            timezone,
          )
          .utc()
      }

      return {
        start: slotStartInUTC,
        end: slotEndInUTC,
      }
    },
    [timezone],
  )

  return { convertDateAndSlotToUTC }
}
